import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { URL_GDPR_PROFILE } from '../../router/constants';
import useAnalytics from '../../hooks/useAnalytics';
import { PERMISSION_GDPR_PROFILE_LIST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Form from '../../components/GdprProfile/Form';

export const Route = createFileRoute('/_authenticated/gdpr-profile/edit/$cid/$id/$count')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_GDPR_PROFILE_LIST, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.gdprProfile',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditGdprProfileThreeParamsRoute,
});

function EditGdprProfileThreeParamsRoute() {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  const handleClose = useCallback(() => {
    navigate({ to: URL_GDPR_PROFILE });
    trackEvent(['gdprProfiles', 'click', 'GDPR profile close']);
  }, [navigate, trackEvent]);

  const { cid, id, count } = Route.useParams();

  return (
    <Form
      closeCallback={handleClose}
      editingItemId={Number(id)}
      customerId={Number(cid)}
      usersCount={Number(count)}
      isEdited
    />
  );
}
